import React from 'react'
import Paper from 'material-ui/Paper'
import { styles } from './Styles'
import Chached from 'material-ui/svg-icons/action/cached'

const PercheSwapick = () => (
  <Paper style={styles.paper}>
    <div>
      <h4 style={styles.titles}>
        <Chached style={styles.titleIcon} />Perchè Swapick?
      </h4>
      <p>
        Swapick è un sito internet che ti consente di
        {' '}
        <strong>vendere</strong>
        ,
        {' '}
        <strong>acquistare</strong>
        {' '}
        e
        {' '}
        <strong>permutare (barattare)</strong>
        {' '}
        i tuoi
        {' '}
        <strong>oggetti usati</strong>
        {' '}
        e da
        {' '}
        <strong>collezione</strong>
        {' '}
        in un modo nuovo, semplice e immediato.
      </p>
      <p>
        Siamo gli unici a dare un servizio di
        {' '}
        <strong>baratto on line</strong>
        , che è la nostra principale caratteristica, insieme alla possibilità di vendere e comprare.
        {' '}
        <br />
        Il nostro nome è l’unione della parola “swap”, che vuol dire scambio (o baratto, permuta) e del verbo “pick” che vuol dire scegliere. Infatti il nostro processo di baratto si basa proprio sulla
        {' '}
        <strong>scelta degli oggetti</strong>
        {' '}
        da dare e da ricevere in cambio.
        <br />
        Il
        {' '}
        <strong>baratto on line</strong>
        {' '}
        su swapick è veramente innovativo, non si tratta di semplici annunci. Infatti, dopo aver aggiunto alle tue liste gli oggetti che possiedi, gli oggetti che vuoi e i tuoi interessi, ti verranno suggeriti in automatico i possibili scambi con gli altri utenti. Non dovrai più perdere ore nella ricerca di qualcuno che voglia scambiare con te e potrai dire addio alle lunghe e noiose liste dei tuoi oggetti da tenere continuamente aggiornate.
      </p>
      <p>
        Su Swapick, inoltre, è possibile fare anche
        {' '}
        <strong>baratto con parziale conguaglio in denaro</strong>
        {' '}
        in modo da compensare eventuali sbilanci di valore tra gli oggetti (o i servizi). Il valore e la compensazione in denaro non vengono stabiliti da noi, ma sono a libera scelta degli utenti.
      </p>
      <p>
        Sulla nostra piattaforma non usiamo crediti (o moneta elettronica) per gli scambi perché pensiamo che il vero baratto sia quello di dare oggetti per oggetti (o anche servizi). Vendere e comprare per mezzo di crediti virtuali, secondo noi, non è baratto. I crediti (eCoin) presenti sul nostro sito servono per acquistare servizi premium.
      </p>
      <p>
        Il processo di baratto su swapick è un’esperienza divertente e, nella maggior parte dei casi, le proposte di baratto vengono accettate perché mirate ad oggetti che l’altro utente vuole.
        <br />
        Con Swapick potrai quindi divertirti nell’ottenere ciò che desideri ed
        {' '}
        <strong>
          evitare di sprecare oggetti per te non più utili
        </strong>
        , ma che lo sono sicuramente per qualcun altro, donandogli così nuova vita!
        <br />
        Non ci resta che invitarti a provare,
        {' '}
        <strong>iscriviti gratuitamente</strong>
        {' '}
        a Swapick!
      </p>
    </div>
  </Paper>
)

export default PercheSwapick



// WEBPACK FOOTER //
// ./src/common/Infotext/PercheSwapick.js